import React from 'react';
import { IoLocationSharp } from "react-icons/io5";
import { FaTelegramPlane } from "react-icons/fa";
import { FaFacebookSquare } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import Header from '../Header/Header';
import './Services.css';

function Services() {
  return (
    <div className='Services_container'>
      <Header />
      <div className='service_bg_image'></div>
      <div className='centered_boxes_container'>
        <div className='centered_box'>
          <div className='service_content'>
            <div className='service_icon'><img src='https://rival.team/upload/service/b1/78/servises2.svg' alt=''></img></div>
            <div className='service_text'>
              <div className='service_main_text'>Мужская стрижка</div>
              <div className='service_sub_text'>
              Мужская стрижка выполняется машинкой и ножницами, с использованием косметики, подобранной для типа волос и стиля.
              </div>
            </div>
          </div>
          <div className='service_price'>200.000 сум</div>
        </div>
        <div className='centered_box'>
          <div className='service_content'>
            <div className='service_icon'><img src='https://rival.team/upload/service/b5/e1/servises1.svg' alt=''></img></div>
            <div className='service_text'>
              <div className='service_main_text'>Моделирования бороды</div>
              <div className='service_sub_text'>
              Моделирование бороды проводится триммером и ножницами с применением средств, подходящих для кожи и формы.
              </div>
            </div>
          </div>
          <div className='service_price'>170.000 сум</div>
        </div>
        <div className='centered_box'>
          <div className='service_content'>
            <div className='service_icon'><img src='https://rival.team/upload/service/36/84/servises3.svg' alt=''></img></div>
            <div className='service_text'>
              <div className='service_main_text'>Чистка лица чёрная маска</div>
              <div className='service_sub_text'>
              Чистка лица с чёрной маской проводится для удаления загрязнений и улучшения состояния кожи.
              </div>
            </div>
          </div>
          <div className='service_price'>150.000 сум</div>
        </div>
        <div className='centered_box'>
          <div className='service_content'>
            <div className='service_icon'><img src='	https://rival.team/upload/service/b4/b0/servises1.svg' alt=''></img></div>
            <div className='service_text'>
              <div className='service_main_text'>Королевский бритьё лица</div>
              <div className='service_sub_text'>
              Королевское бритьё лица выполняется опасной бритвой с использованием средств для увлажнения и защиты кожи.
              </div>
            </div>
          </div>
          <div className='service_price'>170.000 сум</div>
        </div>
        <div className='centered_box'>
          <div className='service_content'>
            <div className='service_icon'><img src='https://rival.team/upload/service/1e/82/servises1.svg' alt=''></img></div>
            <div className='service_text'>
              <div className='service_main_text'>Камуфляж Бороды</div>
              <div className='service_sub_text'>
              Камуфляж бороды выполняется с использованием краски, подобранной для естественного цвета и равномерного покрытия.
              </div>
            </div>
          </div>
          <div className='service_price'>150.000 сум</div>
        </div>
        <div className='centered_box'>
          <div className='service_content'>
            <div className='service_icon'><img src='https://rival.team/upload/service/51/8e/servises2.svg' alt=''></img></div>
            <div className='service_text'>
              <div className='service_main_text'>Стрижка ножницами</div>
              <div className='service_sub_text'>
              Стрижка ножницами проводится вручную, с точной проработкой формы и длины, подбирая стиль под тип волос.
              </div>
            </div>
          </div>
          <div className='service_price'>220.000 сум</div>
        </div>
        <div className='centered_box'>
          <div className='service_content'>
            <div className='service_icon'><img src='	https://rival.team/upload/service/0f/77/servises2.svg' alt=''></img></div>
            <div className='service_text'>
              <div className='service_main_text'>Камуфляж головы</div>
              <div className='service_sub_text'>
              Камуфляж головы проводится с помощью краски, которая подбирается для естественного цвета и маскировки седины.
              </div>
            </div>
          </div>
          <div className='service_price'>170.000 сум</div>
        </div>
        <div className='centered_box'>
          <div className='service_content'>
            <div className='service_icon'><img src='	https://rival.team/upload/service/60/86/servises5.svg' alt=''></img></div>
            <div className='service_text'>
              <div className='service_main_text'>Детская стрижка</div>
              <div className='service_sub_text'>
              Детская стрижка выполняется с учётом особенностей волос и предпочтений ребёнка, создавая комфортную атмосферу.
              </div>
            </div>
          </div>
          <div className='service_price'>150.000 сум</div>
        </div>
        <div className='centered_box'>
          <div className='service_content'>
            <div className='service_icon'><img src='https://rival.team/upload/service/43/40/servises6.svg' alt=''></img></div>
            <div className='service_text'>
              <div className='service_main_text'>Бритьё шейвером</div>
              <div className='service_sub_text'>
              Бритьё шейвером выполняется для гладкой кожи, обеспечивая комфорт и быстрое удаление волос без раздражения.
              </div>
            </div>
          </div>
          <div className='service_price'>120.000 сум</div>
        </div>
        <div className='centered_box'>
          <div className='service_content'>
            <div className='service_icon'><img src='	https://rival.team/upload/service/b1/78/servises2.svg' alt=''></img></div>
            <div className='service_text'>
              <div className='service_main_text'>Стрижка Отец + Сын</div>
              <div className='service_sub_text'>
              Стрижка «Отец + Сын» предполагает совместное посещение, создавая стильные образы для обеих поколений и укрепляя связь.
              </div>
            </div>
          </div>
          <div className='service_price'>300.000 сум</div>
        </div>
        <div className='centered_box'>
          <div className='service_content'>
            <div className='service_icon'><img src='https://rival.team/upload/service/e5/8f/servises3.svg' alt=''></img></div>
            <div className='service_text'>
              <div className='service_main_text'>Воск комплекс</div>
              <div className='service_sub_text'>
              Воск комплекс применяется для укладки волос, обеспечивая стойкость и естественный вид, подчеркивая текстуру прически.
              </div>
            </div>
          </div>
          <div className='service_price'>70.000 сум</div>
        </div>
        <div className='centered_box'>
          <div className='service_content'>
            <div className='service_icon'><img src='	https://rival.team/upload/service/16/81/servises2.svg' alt=''></img></div>
            <div className='service_text'>
              <div className='service_main_text'>Окантовка + мойка головы</div>
              <div className='service_sub_text'>
              Окантовка и мойка головы выполняются для создания аккуратного образа, включая освежение и уход за волосами и кожей головы.
              </div>
            </div>
          </div>
          <div className='service_price'>120.000 сум</div>
        </div>
        <div className='centered_box'>
          <div className='service_content'>
            <div className='service_icon'><img src='	https://rival.team/upload/service/ac/88/servises4.svg' alt=''></img></div>
            <div className='service_text'>
              <div className='service_main_text'>Стрижка пенсионером</div>
              <div className='service_sub_text'>      
Стрижка пенсионером проводится с учётом предпочтений и комфорта клиента, обеспечивая удобный и стильный вид.
              </div>
            </div>
          </div>
          <div className='service_price'>120.000 сум</div>
        </div>
        <div className='centered_box'>
          <div className='service_content'>
            <div className='service_icon'><img src='	https://rival.team/upload/service/e5/8f/servises3.svg' alt=''></img></div>
            <div className='service_text'>
              <div className='service_main_text'>Оформление жениха</div>
              <div className='service_sub_text'>
              Оформление жениха включает стрижку, укладку и Grooming, создавая стильный и ухоженный образ для важного события.
              </div>
            </div>
          </div>
          <div className='service_price'>1 400. 000 сум</div>
        </div>
        <div className='Service_footer'>
          <div className='service_location_box'>
            <div><IoLocationSharp /></div>
            <a href='https://maps.app.goo.gl/cvvgtaPtsXEYdFgw8'>Ташкент, ул.Махтумкули, 62</a>
          </div>
          <div className='service_social_media_box'>
          <a href="https://t.me/@id7285745714"><FaTelegramPlane /></a>
        <a href="http://facebook.com/hawk.strike.uz"><FaFacebookSquare /></a>
        <a href="https://www.instagram.com/hawk_strike_uzb_/"><FaInstagram /></a>
          </div>
        </div>

      </div>
      
    </div>
  );
}

export default Services;
